
import { Component, Vue } from 'vue-property-decorator'
@Component({
    name: 'Video'
})
export default class extends Vue { }
